<template>
  <div slot="body">
    <!-- 弹窗-查询表单 -->
    <div class="md-layout">
      <div class="md-layout-item md-size-25 left-layout-item">
        <md-field>
          <label>{{$I18n("user_id")}}</label>
          <md-input v-model="modalExportSearchData.transfer_sid"/>
        </md-field>
      </div>
      <!-- 按钮-提交查询 -->
      <div class="md-layout-item left-btn" style="text-align: left;">
        <md-button class= "left-icon md-info" @click="modal_changeSearchExportData">
          <md-icon>search</md-icon>
          {{$I18n("search")}}
        </md-button>
      </div>
    </div>
    <!-- 弹窗-表格
      ID，     转移账号，目标服务器，   状态，   结果，     更新时间，     创建时间
     -->

    <md-table style="text-align: left;" v-if="modalExportTableData.length > 0" v-model="modalExportTableData" class="left-table">
      <md-table-row slot="md-table-row" slot-scope="{ item }">
        <md-table-cell :md-label="'ID'">{{ item.transfer_nid }}</md-table-cell>
        <md-table-cell :md-label="$I18n('user_id')">{{ item.transfer_sid }}</md-table-cell>
        <md-table-cell :md-label="$I18n('target_host')">{{ item.target_host }}</md-table-cell>
        <md-table-cell :md-label="$I18n('state')">{{ item._state_name }}</md-table-cell>
        <md-table-cell :md-label="$I18n('state_msg')">{{ item.state_msg }}</md-table-cell>
        <md-table-cell :md-label="$I18n('update_date')">{{ item._update_time }}</md-table-cell>
        <md-table-cell :md-label="$I18n('create_time')">{{ item._create_time }}</md-table-cell>
      </md-table-row>
    </md-table>
    <md-table v-else v-model="modalExportTableData" class="left-table">
      <md-table-row slot="md-table-row" slot-scope="{item}">
        <md-table-cell :md-label="$I18n('update_time')">{{ item.update_time }}</md-table-cell>
        <md-table-cell :md-label="$I18n('update_time')">{{ item.update_time }}</md-table-cell>
        <md-table-cell :md-label="$I18n('update_time')">{{ item.update_time }}</md-table-cell>
        <md-table-cell :md-label="$I18n('update_time')">{{ item.update_time }}</md-table-cell>
      </md-table-row>
      <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
    </md-table>
    <table-page :total="import_export_total" :pageSize="import_pageSize" v-model="import_exportCurrentPage"/>
  </div>
</template>

<script>
import { timestampToString } from "@/common/tools.js";
// import { nDaysAgo, nMonthsAgo, timestampToString1000, formatJsonForNotes, getInitComp } from "@/common/tools.js";
export default {
  data() {
    return {
      modalExportTableInitData: [],
      modalExportSearchData:{
        transfer_sid: "",
        // time: [],
      },
      modalExportSearchForm:{
        transfer_sid: "",
        // time: [],
      },
      import_pageSize: 10,
      import_exportCurrentPage: 1,
      import_export_total: 0,
    }
  },
  watch:{
    import_exportCurrentPage(){
      this.api_getExportXlsxData();
    },
  },
  created(){
    this.api_getExportXlsxData();
  },
  computed:{
    modalExportTableData() {
      if (!this.modalExportTableInitData || this.modalExportTableInitData.length === 0){
        return [];
      } else {
        //  ID，     转移账号，目标服务器，   状态，   结果，     更新时间，     创建时间
        return [...this.modalExportTableInitData.map(item => {
          var state_name = this.$I18n("all");
          if(item.state == 1){
            state_name = this.$I18n("trans_user_state_1")
          } else if(item.state == 2){
            state_name = this.$I18n("trans_user_state_2")
          } else if(item.state == 3){
            state_name = this.$I18n("trans_user_state_3")
          } else if(item.state == 4){
            state_name = this.$I18n("trans_user_state_4")
          } else if(item.state == 5){
            state_name = this.$I18n("trans_user_state_5")
          } else if(item.state == 6){
            state_name = this.$I18n("trans_user_state_6")
          } else if(item.state == 7){
            state_name = this.$I18n("trans_user_state_7")
          }
          return {
            ...item,
            // comp_name,
            _state_name  : state_name,
            _create_time : timestampToString(new Date(item.create_time).getTime()),
            _update_time : timestampToString(new Date(item.update_time).getTime()),
          }
        })]
      }
    },
  },
  methods: {
    modal_changeSearchExportData(){
      this.import_exportCurrentPage = 1;
      this.modalExportSearchForm = {...this.modalExportSearchData}
      this.api_getExportXlsxData();
    },
    api_getExportXlsxData(){
      this.$api.getTransUser({
        ...this.modalExportSearchForm,
        page_size: this.import_pageSize,
        page_no: this.import_exportCurrentPage,
      })
        .then(this.$Then(resData => {
          this.modalExportTableInitData = resData.data;
          this.import_export_total = resData.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.modalExportTableInitData = [];
          this.import_export_total = 0;
        }))
    },
  },
}
</script>